const state = {
    activeTabName: 'main',  //当前页面
    tabList: [
        {
            name: 'main',
            label: '首页',
            closable: false
        }
    ],
    menuTreeListFlatten: [],
    menuTreeList: [],
    breadCrumbList: {
        breadCrumbList: [],
        selectArray: []
    },
    globalProjectVisible: false,
    selectProjectId: '',
}

const mutations = {
    setActiveTabName(state, index) {
        state.activeTabName = index;
    },
    setGlobalProjectVisible(state, index) {
        state.globalProjectVisible = index;
    },
    addTabList(state, index) {
        if (!state.tabList.filter(item => item.name == index).length) {
            var tabName = state.menuTreeListFlatten.filter(item => item.menu_link == index);
            state.tabList.push({
                name: index,
                label: tabName.length ? tabName[0].menu_name : "",
                closable: true
            })
        }
    },
    moveTab(state, index) {
        if (state.activeTabName == index) {
            //关闭当前,跳到上一个页面
            var closeTab = state.tabList.filter(item => item.name == index)[0];
            var tabIndex = state.tabList.indexOf(closeTab);
            state.tabList = state.tabList.filter(item => item.name != index);
            if (tabIndex == 0) {
                vm.$router.push({
                    name: "main"
                });
            } else {
                vm.$router.push({
                    name: state.tabList[tabIndex - 1].name
                });
            }
        } else {
            //关闭非当前页，直接关闭
            state.tabList = state.tabList.filter(item => item.name != index);
        }
    },
    moveAllTab(state) {
        //关闭所有
        state.tabList = state.tabList.filter(item => item.name == 'main');
        vm.$router.push({
            name: "main"
        });
    },
    moveOtherTab(state) {
        //关闭其他
        state.tabList = state.tabList.filter(item => item.name == 'main' || item.name == state.activeTabName);
    },
    setMenuTreeList(state, data) {
        state.menuTreeList = data;
        state.menuTreeListFlatten = arrayChildrenFlatten(state.menuTreeList);
    },
    emptyMenuTreeList(state) {
        state.menuTreeList = [];
        state.menuTreeListFlatten = [];
    },
    isContainMenu(state, menu_link) {
        return (state.menuTreeListFlatten.filter(item => item.menu_link == menu_link).length > 0);
    },
    addBreadCrumb(state, index) {
        state.breadCrumbList.breadCrumbList = [];
        state.breadCrumbList.selectArray = [];
        if (index == "main") {
            state.breadCrumbList.breadCrumbList.splice(0, 0, {
                menu_id: 0,
                menu_pid: 0,
                menu_link: 'main',
                menu_name: '首页'
            });
        } else {
            var mapTab = state.menuTreeListFlatten.filter(item => item.menu_link == index);
            if (mapTab.length > 0) {
                mapTab = mapTab[0];
                state.breadCrumbList.breadCrumbList = findFatherIndex(mapTab, []);
                state.breadCrumbList.selectArray = state.menuTreeListFlatten.filter(item => item.menu_pid == mapTab.menu_pid && (mapTab.menu_pid || !item.children.length));//找到同级节点
                state.breadCrumbList.breadCrumbList.splice(0, 0, {
                    menu_id: 0,
                    menu_pid: 0,
                    menu_link: 'main',
                    menu_name: '首页'
                });
            }
        }
    },
    emptyBreadCrumb(state) {
        state.breadCrumbList.breadCrumbList = [];
        state.breadCrumbList.selectArray = [];
    },
};
/*
*多维数组数组扁平化
*/
function arrayChildrenFlatten(array, result) {
    if (!result) result = [];
    for (var i = 0; i < array.length; i++) {
        var item = array[i];
        result.push(item);
        if (item.children && item.children.length > 0) {
            result = arrayChildrenFlatten(item.children, result);
        }
    }
    return result;
}
function findFatherIndex(mapTab, array) {
    array.splice(0, 0, {
        menu_id: mapTab.menu_id,
        menu_pid: mapTab.menu_pid,
        menu_link: mapTab.menu_link,
        menu_name: mapTab.menu_name
    })
    if (mapTab.menu_pid > 0) {
        var mapTabF = state.menuTreeListFlatten.filter(item => item.menu_id == mapTab.menu_pid);
        if (mapTabF.length) {
            mapTabF = mapTabF[0];
            findFatherIndex(mapTabF, array);
        }
    }
    return array;
}

const getters = {

};

const actions = {

};
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}